import React from "react";

// Icon
import { UploadOutlined } from "@ant-design/icons";

// Antd
import { message, Upload, Form } from "antd";

// Style
import "./style.scss";

// Localization
import LOCALIZATION from "../../../../services/LocalizationService";

const Index = ({
  listType,
  placeholder,
  label,
  notwrapInForm,
  name,
  validateTrigger,
  valuePropName,
  type,
  icon,
  maxCount,
  onChange,
  accept,
  required,
  validator,
  fileList,
  onRemove,
  onUplaodAction,
  hideDragger,
}) => {
  const { Dragger } = Upload;
  const props = {
    beforeUpload: (file) => {
      // Define allowed file types based on accept prop or default to Excel/CSV
      const allowedTypes = accept 
        ? accept.split(',').map(type => type.trim())
        : ['.xlsx', '.xls', '.csv'];
      
      const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
      const mimeTypeMap = {
        '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        '.xls': 'application/vnd.ms-excel',
        '.csv': 'text/csv',
        '.pdf': 'application/pdf',
        '.doc': 'application/msword',
        '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        '.jpg': 'image/jpeg',
        '.jpeg': 'image/jpeg',
        '.png': 'image/png',
        '.gif': 'image/gif'
      };
      
      const isValidExtension = allowedTypes.some(allowedType => 
        allowedType.toLowerCase() === fileExtension
      );
      
      const isValidMimeType = allowedTypes.some(allowedType => {
        const expectedMimeType = mimeTypeMap[allowedType.toLowerCase()];
        return expectedMimeType && file.type === expectedMimeType;
      });
      
      const isValidFile = isValidExtension || isValidMimeType;
      
      if (!isValidFile) {
        message.error(`You can only upload ${allowedTypes.join(', ')} files!`);
      }
      
      // Check file size (default 25MB limit)
      const maxSize = 25 * 1024 * 1024; // 25MB in bytes
      if (file.size > maxSize) {
        message.error('File size must be less than 25MB!');
        return false;
      }
      
      return onUplaodAction === false ? false : isValidFile;
    },

    progress: {
      strokeColor: {
        "0%": "#E31837",
        "20%": "#E31837",
        "50%": "#E31837",
        "70%": "#E31837",
        "100%": "#E31837",
      },
      strokeWidth: 3,
      format: (percent) => percent && `${parseFloat(percent.toFixed(2))}%`,
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  const FileUpload = (
    <div
      className={hideDragger ? "hide-dragger" : ""}
    >
      <Dragger
        listType={listType}
        {...props}
        type={type}
        name={name}
        maxCount={maxCount}
        onChange={onChange}
        accept={accept}
        fileList={fileList}
        onRemove={onRemove}
      >
        <p className="ant-upload-drag-icon">
          {icon ? icon : <UploadOutlined style={{ color: "#ccff00" }} />}
        </p>
        <p className="ant-upload-text">
          {placeholder || "Drag files here or click to upload"}
        </p>
        <p className="ant-upload-hint">
          {accept 
            ? `Allowed file types: ${accept.replace(/\./g, '').toUpperCase()}`
            : "Maximum file size: 25MB • Maximum files: 10"
          }
        </p>
      </Dragger>
    </div>
  );

  let rules = [{ required: required, message: LOCALIZATION.REQUIRED }];

  !!validator && rules.push(validator);

  return !!notwrapInForm ? (
    <>{FileUpload}</>
  ) : (
    <Form.Item
      name={name}
      label={label}
      validateTrigger={validateTrigger || "onBlur"}
      rules={rules}
      valuePropName={valuePropName}
      getValueFromEvent={(e) => {
        if (Array.isArray(e)) {
          return e;
        }
        return e && e.fileList;
      }}
    >
      {FileUpload}
    </Form.Item>
  );
};

export default Index;
